import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';

export class HoZuHu extends BaseModel {
    // properties
    id: number | null = null;
    faktor: number | null = null;

    getClassName(): string {
        return 'HoZuHu';
    }
}

export class HoZuHuCollection extends BaseCollection<HoZuHu> {
    protected modelCls = HoZuHu;

    public getModelClassName(): string {
        return 'HoZuHu';
    }
}

let _globalHoZuHuCollection: HoZuHuCollection | null = null;

/**
 * global (single instance) collection: To be used where a global, shared instance can be used.
 * Note that this collection MUST NOT be filered / ordered on other places, as it is a shared instance!
 * @returns
 */
export async function globalHoZuHuCollection(): Promise<HoZuHuCollection> {
    if (!_globalHoZuHuCollection) {
        const collection = new HoZuHuCollection();
        collection.setQueryParams({});
        await collection.query();
        _globalHoZuHuCollection = collection;
    }
    return _globalHoZuHuCollection;
}
